<template>
  <div class="fullHeigthPage">
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <!-- FORMULARIO -->
      <div class="col-md-4">
        <b-card class="heightCardHeader" data-v-step="1">
          <b-card-title> Consultar </b-card-title>
          <b-form-group label="Mês referência" invalid-feedback="campo obrigatório" class="col-md-12 mb-3" :state="state('mesReferencia')">
            <multiselect 
              v-model="dados.mesReferencia"
              placeholder="Selecione" :show-labels="false"
              :options="optionMesReferencia" :allow-empty="false"
              :custom-label="({ dt_referencia }) => customLabelReferencia(dt_referencia) "
              @input="inputReferencia"
              :max-height="200" 
              data-v-step="3" />
          </b-form-group>
          <b-form-group label="Projeto" invalid-feedback="campo obrigatório" class="col-md-12" :state="state('projeto')">
            <multiselect 
              v-model="dados.projeto" 
              placeholder="Selecione" 
              :show-labels="false" 
              :options="optionProjeto"
              :allow-empty="false" 
              @input="inputProjeto" 
              :custom-label="({ nm_projeto, cd_projeto }) => `${nm_projeto} - [${cd_projeto}]`" 
              data-v-step="2" />
          </b-form-group>
          <!-- BOTÕES -->
          <div class="row">
            <div class="col-4 mt-1">
              <b-button variant="light" @click="iniciarTour()" class="mt-1">
                <i class="mdi mdi-help-circle font-size-16 align-middle me-2"></i>
                Ajuda
              </b-button>
            </div>

            <div class="col-8 mt-1 d-flex justify-content-end">
              <b-button @click="limparPesquisa()" class="mt-1 me-1" data-v-step="4" :disabled="executarTour">
                <i class="mdi mdi-broom font-size-16 align-middle me-1"></i>
                Limpar
              </b-button>
              <b-button variant="primary" @click="filtrarRdv()" class="mt-1" data-v-step="5">
                <i class="mdi mdi-filter-outline font-size-16 align-middle me-1"></i>
                Filtrar
              </b-button>
            </div>
          </div>
        </b-card>
      </div>
      <!--INFORMAÇÕES RDV-->
      <div class="col-md-4" v-if="viewInfoRDV">
        <b-card class="heightCardHeader" data-v-step="6">
          <b-card-title class="mb-4">
            Informações do RDV -
            <span class="badge badge-pill badge-soft-secondary font-size-15">
              {{ this.cabecalhoRdv.cd_rdv }}
            </span>
          </b-card-title>
          <div class="text-center">
            <h5 class="text-muted">
              Status do RDV
              <i class="bx bxs-help-circle font-size-20 div-clickable" @click="tourHelp('resumoRdv')"
                data-v-step="7"></i>
            </h5>
            <h5 class="badge badge-pill font-size-18 mb-3" :style="'background:' + this.cabecalhoRdv.ds_cor_app_st_rdv">
              {{ this.cabecalhoRdv.ds_st_rdv }}
            </h5>
            <h5 class="text-muted">Período</h5>
            <h5 class="text-dark mb-3">
              {{
      this.$tools.converteData(
        this.cabecalhoRdv.dt_inicio.substr(0, 10)
      )
    }}
              a
              {{
        this.$tools.converteData(this.cabecalhoRdv.dt_fim.substr(0, 10))
      }}
            </h5>
            <h5 class="text-muted">Projeto</h5>
            <h5 class="text-dark mb-3">{{ this.cabecalhoRdv.nm_projeto }}</h5>
            <div v-if="this.cabecalhoRdv.ds_st_rdv === 'Liquidado'">
              <h5 class="text-muted">Qtd. De Despesas Lançadas</h5>
              <h5 class="text-dark mb-0">
                <!-- <span class="badge badge-pill badge-soft-secondary"
                  >TOTAL {{ despesaTotal }}</span
                >
                sendo -->
                <span class="badge badge-pill badge-soft-success m-1">{{ despesaAprovada }} Aprovado(s)</span>
                <span class="badge badge-pill badge-soft-danger m-0">{{ despesaRejeitada }} Rejeitado(s)</span>
              </h5>
            </div>
            <div class="d-flex justify-content-center">
              <b-button variant="primary" class="col-md-6 me-1" @click="abrirModalNormas()">
                <i class="mdi mdi-eye align-middle me-2"></i>
                Limites da Norma
              </b-button>
            </div>
          </div>
        </b-card>
      </div>
      <!--RESUMO DESPESASA-->
      <div class="col-md-4" v-if="viewValoresRDV">
        <b-card class="heightCardHeader" v-if="cabecalhoRdv.st_rdv != 'L'" data-v-step="8">
          <div class="d-flex">
            <b-card-title class="mb-4"> Valores do RDV </b-card-title>
            <label v-if="cabecalhoRdv.nr_contrato == 'ORBIA'">
              {{ cabecalhoRdv.ds_periodo }}</label>
          </div>
          <div class="row">
            <div class="col-md-10">
              <div class="d-flex justify-content-between">
                <div class="col-md-8">
                  <h6 class="text-muted">
                    <i class="mdi mdi-circle text-secondary align-middle me-1" />
                    <span v-if="cabecalhoRdv.nr_contrato != 'ORBIA'">Limite Mensal</span>
                    <span v-else>Limite {{ cabecalhoRdv.ds_meses_periodo }}</span>
                  </h6>
                </div>
                <h5 v-if="cabecalhoRdv.nr_contrato != 'ORBIA'" class="text-secondary">
                  {{ $tools.converteReal(cabecalhoRdv.vl_limite) }}
                </h5>
                <h5 v-else>
                  {{ $tools.converteReal(cabecalhoRdv.vl_limite_periodo) }}
                </h5>
              </div>
              <hr class="mt-1" />
              <div class="d-flex justify-content-between">
                <div class="col-md-8">
                  <h6 class="text-muted">
                    <i class="mdi mdi-circle text-primary align-middle me-1" />
                    <span v-if="cabecalhoRdv.nr_contrato != 'ORBIA'">Despesas Lançadas</span>
                    <span v-else>Despesas lançadas (neste RDV)</span>
                  </h6>
                </div>
                <strong class="text-primary font-size-18 mb-2">{{
      $tools.converteReal(cabecalhoRdv.vl_despesa)
    }}</strong>
              </div>
              <hr class="mt-1" />
              <div class="d-flex justify-content-between">
                <div class="col-md-8">
                  <h6 class="text-muted">
                    <i class="mdi mdi-circle text-success align-middle me-1" />
                    <span v-if="cabecalhoRdv.nr_contrato != 'ORBIA'">Limite disponível</span>
                    <span v-else>Disponível {{ cabecalhoRdv.ds_meses_periodo }}</span>
                  </h6>
                </div>
                <h5 :class="saldoDisponivel < 0 ? 'text-danger' : 'text-success'">
                  {{
      cabecalhoRdv.nr_contrato != "ORBIA"
        ? $tools.converteReal(saldoDisponivel)
        : $tools.converteReal(cabecalhoRdv.vl_disponivel)
    }}
                </h5>
              </div>
              <hr class="mt-1" />
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center" data-v-step="9">
              <div class="despesasTotaisLinha" :data-tooltip="'Total Despesas ' + porcentagemDespesas.toFixed(1) + '%'
      " data-tooltip-location="left" style="border-radius: 0.25rem 0.25rem 0 0 !important"
                :style="'height: ' + porcentagemDespesas.toFixed(1) + '%;'" />
              <div class="disponivelLinha" :data-tooltip="'Disponivel ' + porcentagemDisponivel.toFixed(1) + '%'
      " data-tooltip-location="left" style="border-radius: 0 0 0.25rem 0.25rem !important"
                :style="'height: ' + porcentagemDisponivel.toFixed(1) + '%;'" />
            </div>
          </div>
          <div class="mt-2">
            <b-button variant="primary" @click="emitirRelatorio()" class="col-md-12" :disabled="viewEmitirRelatorio"
              data-v-step="10">
              <i class="mdi mdi-printer font-size-16 align-middle me-2"></i>
              Visualizar Folha de Rosto e Comprovantes
              <b-spinner small class="ms-2" v-if="viewEmitirRelatorio"></b-spinner>
            </b-button>
          </div>
          <div class="mt-1 d-flex justify-content-between" v-if="executarTour" data-v-step="11">
            <b-button variant="primary" class="col-md-6 me-1">
              <i class="mdi mdi-printer font-size-18 align-middle me-2"></i>
              Folha de Rosto
            </b-button>
            <b-button variant="primary" class="col-md-6">
              <i class="mdi mdi-printer font-size-18 align-middle me-2"></i>
              Extrato do Acerto
            </b-button>
          </div>
        </b-card>
        <b-card class="heightCardHeader" v-else>
          <b-card-title> Resumo do RDV </b-card-title>
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex justify-content-between">
                <h5 class="text-muted">Lançamentos</h5>
                <h5>{{ $tools.converteReal(cabecalhoRdv.vl_despesa) }}</h5>
              </div>
              <hr class="mt-1" />
              <div class="d-flex justify-content-between">
                <h5 class="text-muted">
                  {{ cabecalhoRdv.natureza_acerto }}
                </h5>
                <h5 :class="cabecalhoRdv.vl_previsao_acerto < 0
      ? 'text-danger'
      : 'text-success'
      ">
                  {{ $tools.converteReal(cabecalhoRdv.vl_previsao_acerto) }}
                </h5>
              </div>
              <hr class="mt-1" />
              <div class="d-flex justify-content-between">
                <h5 class="text-muted">
                  {{ cabecalhoRdv.previsao_acerto }}
                </h5>
              </div>
              <hr class="mt-1" />
            </div>
          </div>
          <div class="mt-1 d-flex justify-content-between">
            <b-button variant="primary" @click="emitirRelatorio()" class="col-md-6 me-1"
              :disabled="viewEmitirRelatorio">
              <i class="mdi mdi-printer font-size-18 align-middle me-2"></i>
              Folha de Rosto
              <b-spinner small class="ms-2" v-if="viewEmitirRelatorio"></b-spinner>
            </b-button>
            <b-button variant="primary" class="col-md-6" :disabled="viewEmitirRelatorio" @click="emitirExtratoDeAcerto">
              <i class="mdi mdi-printer font-size-18 align-middle me-2"></i>
              Extrato do Acerto
              <b-spinner small class="ms-2" v-if="viewEmitirRelatorio"></b-spinner>
            </b-button>
          </div>
        </b-card>
      </div>
    </div>
    <!--CARTEIRAS-->
    <div class="row">
      <div class="d-flex justify-content-center" v-if="loading">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
      </div>
      <div class="col-md-12 mb-4" v-if="viewCarteiras" data-v-step="12">
        <VueSlickCarousel v-bind="settings" :arrows="true" :dots="true">
          <div class="mb-3" v-for="(dado, index) in dadosCards" :key="index">
            <b-card class="m-1 p-1 heightCardCarteiras">
              <div :class="'card text-white mb-0'" :style="'background: ' +
      dado.ds_cor_web +
      '; height: 178px;border-radius: 13px;'
      ">
                <div class="card-body d-flex flex-column justify-content-between">
                  <!-- NOME CARTEIRA E IMAGEM -->
                  <div class="row align-items-center">
                    <div class="d-flex justify-content-between">
                      <strong class="font-size-18">{{
      dado.ds_carteira
    }}</strong>
                      <b-card-img v-if="dado.ds_carteira != 'Recurso próprio'"
                        :src="verificarImagemCarteira(dado.ds_icone_app)" class="rounded-0 logo-cards"></b-card-img>
                    </div>
                  </div>
                  <!-- NUMERO CARTAO -->
                  <div class="d-flex flex-column mt-3">
                    <div>
                      <p class="text-white fs-3">
                        {{ dado.ds_detalhe_carteira }}
                      </p>
                    </div>
                    <div v-if="dado.ds_carteira === 'Adiantamento' &&
      cabecalhoRdv.st_rdv == 'A'
      " data-v-step="7">
                      <!-- <router-link :to="'/cooperado/rdv/carteira/adiantamento/solicitacao/'+cabecalhoRdv.cd_rdv"> -->
                      <a @click="redirecionaSolicitacaoAdiantamento()" class="div-clickable">
                        <strong class="text-white text-uppercase text-decoration-underline">
                          Clique aqui para solicitar um adiantamento
                        </strong>
                      </a>
                      <!-- </router-link> -->
                    </div>
                  </div>
                  <!-- NOME CARTAO -->
                  <div class="mt-1" v-if="dado.ds_carteira == 'Visa'">
                    <h6 class="text-white mb-0 fs-5">
                      Limite do cartão:
                      {{ $tools.converteReal(dado.vl_limite) }}
                    </h6>
                  </div>
                  <div class="mt-1" v-else-if="dado.ds_carteira != 'Adiantamento'">
                    <h6 class="text-white mb-0">
                      {{ dado.ge_pessoa.nm_razao }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="row mt-2" data-v-step="13">
                <div class="d-flex justify-content-between">
                  <div v-if="dado.ds_carteira == 'Recurso próprio'">
                    <h6 class="text-muted text-truncate">Lançamentos Totais</h6>
                    <h4 class="text-dark">
                      {{ $tools.converteReal(dado.vl_movto) }}
                    </h4>
                  </div>
                  <div v-else-if="dado.ds_carteira == 'Good Card'">
                    <h6 class="text-muted text-truncate">Comprovados</h6>
                    <h4 class="text-dark">
                      {{ $tools.converteReal(dado.vl_lcto) }}
                    </h4>
                  </div>
                  <div v-else-if="dado.ds_carteira == 'Adiantamento'">
                    <h6 class="text-muted text-truncate">Comprovados</h6>
                    <h4 class="text-dark">
                      {{ $tools.converteReal(dado.vl_lcto) }}
                    </h4>
                  </div>
                  <div v-else-if="dado.ds_carteira == 'Visa'">
                    <h6 class="text-muted text-truncate">Limite Disponível</h6>
                    <h4 class="text-dark">
                      {{ $tools.converteReal(dado.vl_disponivel) }}
                    </h4>
                  </div>
                  <div v-else>
                    <h6 class="text-muted text-truncate">Lançamentos totais</h6>
                    <h4 class="text-dark">
                      {{ $tools.converteReal(dado.vl_lcto) }}
                    </h4>
                  </div>

                  <div class="text-end">
                    <h6 class="text-muted text-truncate" v-if="dado.ds_carteira == 'Recurso próprio'"></h6>
                    <h6 class="text-muted text-truncate" v-else-if="dado.ds_carteira == 'Good Card' ||
      dado.ds_carteira == 'Adiantamento'
      ">
                      Não Comprovados
                    </h6>
                    <h6 class="text-muted text-truncate" v-else-if="dado.ds_carteira == 'Visa'">
                      Transações
                    </h6>
                    <h6 class="text-muted text-truncate" v-else-if="dado.ds_carteira == 'Mastercard'">
                      Disponivel
                    </h6>
                    <h4 v-if="dado.ds_carteira == 'Recurso próprio'"></h4>
                    <h4 v-else-if="dado.ds_carteira == 'Good Card' ||
      dado.ds_carteira == 'Adiantamento'
      " class="text-danger">
                      {{ $tools.converteReal(dado.vl_disponivel) }}
                    </h4>
                    <h4 v-else-if="dado.ds_carteira == 'Visa'" :class="{
      'text-success': parseInt(dado.vl_movto) > 0,
      'text-danger': parseInt(dado.vl_movto) < 0,
    }">
                      {{ $tools.converteReal(dado.vl_movto) }}
                    </h4>
                    <h4 v-else-if="dado.ds_carteira == 'Mastercard'" :class="{
      'text-success': parseInt(dado.vl_disponivel) > 0,
      'text-danger': parseInt(dado.vl_disponivel) < 0,
    }">
                      {{ $tools.converteReal(dado.vl_disponivel) }}
                    </h4>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-2 mb-0">
                  <div>
                    <h6 class="text-muted text-truncate mb-0" v-if="dado.ds_carteira == 'Recurso próprio'"></h6>
                    <h6 class="text-muted text-truncate mb-0" v-else-if="dado.ds_carteira == 'Adiantamento'">
                      Valor Solicitado
                    </h6>
                    <h6 class="text-muted text-truncate mb-0" v-else-if="dado.ds_carteira == 'Good Card'">
                      Transações
                    </h6>
                    <h6 class="text-muted text-truncate mb-0" v-else-if="dado.ds_carteira == 'Mastercard'">
                      Limite do cartão
                    </h6>
                    <h6 class="text-muted text-truncate mb-0" v-else-if="dado.ds_carteira == 'Visa'">
                      Comprovados
                    </h6>

                    <h5 class="text-dark" v-if="dado.ds_carteira == 'Recurso próprio'"></h5>
                    <h5 class="text-dark" v-if="dado.ds_carteira == 'Visa'">
                      {{ $tools.converteReal(dado.vl_lcto) }}
                    </h5>
                    <h5 class="text-dark" v-else>
                      {{ $tools.converteReal(dado.vl_movto) }}
                    </h5>
                  </div>
                  <div class="text-end">
                    <!-- Depois que terminar os teste, remover o comentário abaixo -->
                    <b-button v-if="dado.ds_carteira == 'Adiantamento' &&
                      statusRdv &&
                      dado.vl_disponivel > 0
                      " @click="redirecionarParaCarteiras('N', 'Adiantamento')" class="btn-lg btn-primary" variant="primary"
                      data-v-step="14">
                      <i class="bx bx-plus" />
                      Incluir
                    </b-button>
                    <b-button v-if="dado.ds_carteira == 'Recurso próprio' && statusRdv"
                      @click="redirecionarParaCarteiras('N', 'Recurso próprio')" class="btn-lg" variant="primary"
                      data-v-step="15">
                      <i class="bx bx-plus" />
                      Incluir
                    </b-button>
                    <h6 class="text-muted text-truncate mb-0" v-if="dado.ds_carteira == 'Visa'">
                      Não comprovados
                    </h6>
                    <h5 class="text-dark" v-if="dado.ds_carteira == 'Visa'">
                      {{ $tools.converteReal(dado.vl_nao_comprovado) }}
                    </h5>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
    <!--TABELA DE DESPESAS-->
    <div class="row" data-v-step="16">
      <div class="col-md-12" v-if="viewDespesas">
        <b-card>
          <div class="row">
            <div class="col-md-8">
              <b-card-title> Transações e Despesas </b-card-title>
            </div>
            <div class="col-md-2">
              <b-form-group>
                <multiselect v-model="filtragemBadge" placeholder="Filtrar por pendências" :show-labels="false"
                  :options="optionTabela" :multiple="true" :preserve-search="true" @input="filtraTabelaCheckbox()" />
              </b-form-group>
            </div>
            <div class="col-md-2">
              <label>
                <b-form-input v-model="filtro" @input="filtrarTabelaDespesa()" type="search"
                  placeholder="Pesquisar..."></b-form-input>
              </label>
            </div>
          </div>
          <b-table class="datatables" responsive="sm" :fields="camposDespesas" :items="tabelaDespesas"
            :filter="filtroAux" :per-page="perPage" :current-page="currentPage" tbody-tr-class="alinhar-tr" striped
            @filtered="onFiltered" foot-clone>
            <template v-slot:cell(ds_norma)="data">
              <div v-if="data.item.ds_tipo_carteira == 'A' ||
      data.item.ds_tipo_carteira == 'P'
      ">
                <span> {{ data.item.ds_norma }}</span>
              </div>
              <div v-else-if="data.item.ds_tipo_carteira == 'M'">
                <span> {{ data.item.estabelecimento_mastercard }} </span>
              </div>
              <div v-else-if="data.item.ds_tipo_carteira == 'V'">
                <span> {{ data.item.estabelecimento_visa }} </span>
              </div>
              <div v-else-if="data.item.ds_tipo_carteira == 'U'">
                <span> {{ data.item.estabelecimento_frota }} </span>
              </div>
            </template>

            <template v-slot:cell(ds_carteira)="data">
              <div class="d-flex">
                <div class="retangulo mr-2" :style="'background-color: ' +
      dadosCards.find(
        (el) => el.ds_carteira == data.item.ds_carteira
      ).ds_cor_web
      "></div>
                <span>{{ data.item.ds_carteira }}</span>
              </div>
            </template>

            <template v-slot:cell(vl_lancamento)="data">
              <div v-if="data.item.ds_tipo_carteira == 'M' ||
      data.item.ds_tipo_carteira == 'V'
      ">
                {{
      $tools.converteReal(
        data.item.despesas.reduce(
          (a, b) => a + parseFloat(b.vl_lancamento),
          0
        ),
        true
      )
    }}
              </div>
              <div else v-if="data.item.ds_tipo_carteira != 'M' &&
      data.item.ds_tipo_carteira != 'V'
      ">
                {{ $tools.converteReal(data.item.vl_lancamento) }}
              </div>
            </template>

            <template v-slot:cell(ds_st_lancamento)="data">
              <span v-if="data.item.ds_tipo_carteira == 'P' ||
      data.item.ds_tipo_carteira == 'A' ||
      data.item.ds_tipo_carteira == 'U'
      " class="badge badge-pill font-size-12" :class="$tools.corBadge(data.item.st_lancamento)">
                {{ data.value }}
              </span>
              <span v-else-if="data.item.ds_tipo_carteira == 'M' ||
      data.item.ds_tipo_carteira == 'V'
      ">
                {{
      $tools.converteReal(
        parseFloat(data.item.vl_original) -
        data.item.despesas.reduce(
          (a, b) => a + parseFloat(b.vl_lancamento),
          0
        )
      )
    }}
              </span>
            </template>

            <template v-slot:cell(pendencias)="data">
              <div data-v-step="17" v-if="!data.item.sq_transacao_motivo_falta">
                <span v-for="(pendencia, index) in verificarPendencias(data.item)" :key="index"
                  :class="'badge badge-pill font-size-12 m-2 ' + pendencia.cor">
                  {{ pendencia.nome }}
                </span>
              </div>
              <div v-else>
                <span class="'badge badge-pill font-size-12 m-2 badge-soft-primary">
                  Transação Justificada Sem Despesa
                </span>
              </div>
            </template>

            <template v-slot:cell(acoes)="data">
              <div class="align-self-center mt-1 text-end" v-if="statusRdv">
                <!-- Justificativa Despesa -->
                <b-button variant="primary" @click="redirecionarParaJustificativa('N', data.item)" data-v-step="18"
                    data-tooltip="Justificar Falta de Comprovação" data-tooltip-location="left" v-if="data.item.despesas.length == 0 &&
                  (data.item.st_lancamento == 'NV' ||
                    data.item.ds_carteira == 'Good Card') &&
                  data.item.ds_carteira != 'Recurso próprio' &&
                  data.item.ds_carteira != 'Adiantamento'
                  ">
                  <i class="mdi mdi-file-document-edit font-size-16" />
                </b-button>
                <!-- 2 Despesa  -->
                <b-button v-if="data.item.st_lancamento === 'P' ||
                    data.item.st_lancamento === 'J'
                    " variant="primary" data-v-step="21" class="ms-2" @click="
                    redirecionarParaCarteiras(
                      'E',
                      data.item.ds_carteira,
                      data.item
                    )
                    " data-tooltip="Editar" data-tooltip-location="left">
                  <i class="mdi mdi-lead-pencil font-size-16" />
                </b-button>
                <b-button v-if="data.item.ds_tipo_carteira == 'V' ||
                  data.item.ds_tipo_carteira == 'M'
                  " variant="primary" @click="
                  redirecionarParaCarteiras(
                    'N',
                    data.item.ds_carteira,
                    data.item
                  )
                  " class="ms-2" data-v-step="19" data-tooltip="Incluir Despesa" data-tooltip-location="left">
                  <i class="mdi mdi-plus-thick font-size-16" />
                </b-button>

                <!-- Excluir Despesa -->
                <b-button variant="danger" @click="removerDespesa(data.item, data.item.ds_carteira)" data-v-step="22"
                  class="ms-2" data-tooltip="Excluir Despesa" data-tooltip-location="left" :disabled="loadingExcluir"
                  v-if="(data.item.st_lancamento === 'P' &&
                          data.item.ds_carteira != 'Good Card') ||
                          (data.item.st_lancamento === 'J' &&
                            data.item.ds_carteira != 'Good Card')
                          ">
                  <i class="fas mdi mdi-trash-can font-size-16" />
                  <b-spinner small v-if="loadingExcluir"></b-spinner>
                </b-button>

                <b-button v-if="executarTour && data.item.ds_tipo_carteira == 'V'" variant="primary" class="ms-2"
                  data-v-step="20">
                  <i class="mdi mdi-eye font-size-16" />
                </b-button>
              </div>

              <!-- Carteiras de Recurso Próprio e Adiantamento -->
              <div v-else-if="data.item.ds_tipo_carteira != 'M' &&
                data.item.ds_tipo_carteira != 'V'
                ">
                  <b-button v-if="(cabecalhoRdv.st_rdv === 'A' ||
                    cabecalhoRdv.st_rdv === 'R') &&
                    (data.item.st_lancamento === 'P' ||
                      data.item.st_lancamento === 'J')
                    " variant="primary" @click="
                    redirecionarParaCarteiras(
                      'E',
                      data.item.ds_carteira,
                      data.item
                    )
                  ">
                    <i class="mdi mdi-lead-pencil font-size-16" />
                  </b-button>

                  <b-button v-else variant="primary" @click="
                    redirecionarParaCarteiras(
                      'V',
                      data.item.ds_carteira,
                      data.item
                    )
                    ">
                  <i class="mdi mdi-eye font-size-16" />
                </b-button>
              </div>
            </template>

            <template v-slot:cell(detail)="data">
              <b-button v-if="data.item.despesas.length > 0" @click="data.toggleDetails" :variant="verificarDespesasRejeitadas(data.item, ['R', 'J'])
                ? 'danger'
                : 'success'
                " data-v-step="23" class="">
                          <i v-if="data.detailsShowing" class="mdi mdi-arrow-down-bold font-size-16"></i>
                          <i v-else class="mdi mdi-arrow-right-bold font-size-16"></i>
                          {{ data.item.despesas.length }}
                        </b-button>
                        <div v-if="data.item.ds_tipo_carteira == 'A' ||
                data.item.ds_tipo_carteira == 'P'
                ">
                <span class="material-icons m-1 rounded-circle text-center badge"
                  :style="'background-color: ' + data.item.ds_cor_web" style="color: #fff; font-size: 18px">
                  <i :class="'mdi ' + data.item.ds_icone_web"></i>
                </span>
              </div>
            </template>

            <template #row-details="data">
              <b-card>
                <b-table class="datatables" responsive="sm" :fields="camposDespesasTransacoes"
                  :items="data.item.despesas" data-v-step="24">
                  <template v-slot:cell(ds_norma)="row">
                    <span class="material-icons m-1 rounded-circle text-center badge"
                      :style="'background-color: ' + row.item.ds_cor_web" style="color: #fff; font-size: 18px">
                      <i :class="'mdi ' + row.item.ds_icone_web"></i>
                    </span>
                    <span>
                      {{ row.item.ds_norma }}
                    </span>
                  </template>

                  <template v-slot:cell(ds_st_lancamento)="row">
                    <span class="badge badge-pill font-size-12" :class="{
      'badge-soft-primary': row.value === 'Liberado',
      'badge-soft-danger': row.value === 'Não Vinculado',
      'badge-soft-danger': row.value === 'Rejeitado',
      'badge-soft-secondary': row.value === 'Pré-rejeitado',
      'badge-soft-warning': row.value === 'Pendente',
      'badge-soft-info': row.value === 'Pré-aprovado',
      'badge-soft-success': row.value === 'Aprovado',
    }">
                      {{ row.value }}
                    </span>
                  </template>

                  <template v-slot:cell(acoes)="row">
                    <div class="me-2 align-self-center mt-1 text-end" v-if="statusRdv &&
      (row.item.st_lancamento == 'P' ||
        row.item.st_lancamento == 'J')
      ">
                      <b-button variant="primary" class="me-2" @click="
      redirecionarParaCarteiras(
        'E',
        row.item.ds_carteira,
        row.item
      )
      ">
                        <i class="mdi mdi-lead-pencil font-size-16" />
                      </b-button>
                      <b-button variant="danger" @click="removerDespesa(row.item, data)" :disabled="loadingExcluir"
                        v-if="data.item.ds_carteira != 'Good Card'">
                        <i class="mdi mdi-trash-can font-size-16" />
                        <b-spinner small v-if="loadingExcluir"></b-spinner>
                      </b-button>
                    </div>

                    <div class="me-2 align-self-center mt-1 text-end" v-else>
                      <b-button v-if="cabecalhoRdv.st_rdv == 'F' &&
      (data.item.st_lancamento === 'P' ||
        data.item.st_lancamento === 'J')
      " variant="primary" @click="
      redirecionarParaCarteiras(
        'E',
        row.item.ds_carteira,
        row.item
      )
      ">
                        <i class="mdi mdi-lead-pencil font-size-16" />
                      </b-button>
                      <b-button v-else variant="primary" @click="
      redirecionarParaCarteiras(
        'V',
        row.item.ds_carteira,
        row.item
      )
      ">
                        <i class="mdi mdi-eye font-size-16" />
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-card>
            </template>

            <template #foot()="">
              <h6></h6>
            </template>

            <template #foot(ds_norma)="">
              <div class="text-end">
                <span class="text-dark fw-bold">TOTAL:</span>
              </div>
            </template>

            <template #foot(vl_original)="">
              <div class="text-end">
                <span class="text-dark fw-bold">{{
      $tools.converteReal(totalLancamentoSemTransacoes)
    }}</span>
              </div>
            </template>

            <template #foot(vl_lancamento)="">
              <div class="text-end">
                <span class="text-dark fw-bold">{{
      $tools.converteReal(cabecalhoRdv.vl_despesa)
    }}</span>
              </div>
            </template>
          </b-table>
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </b-card>
      </div>
    </div>

    <veiculo ref="veiculo" :statusRdv="statusRdv" v-on:comprovante="buscarComprovante" />

    <telemetria ref="telemetria" />
    <!-- Se o tipo do comprovante não for PDF, exibir o modal com imagens -->
    <vue-easy-lightbox v-if="notaCombustivel.tipoComprovante != 'pdf'" :visible="showModalNota"
      :imgs="notaCombustivel.comprovante" @hide="showModalNota = false"></vue-easy-lightbox>

    <b-modal v-else v-model="showModalNota" title-class="font-18" hide-footer>
      <embed :src="notaCombustivel.comprovante" style="height: 500px; width: 100%" />
    </b-modal>

    <limitesNormas ref="normasModal" />

    <v-tour name="tourRdvCooperado" :steps="stepsTour" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>
    <!-- <v-tour name="tourResumo" :steps="stepsResumo" :options="tourOptions"></v-tour> -->
    <!-- <v-tour name="tourDespesa" :steps="stepsDespesa" :options="tourOptions"></v-tour>
    <v-tour name="tourInfo" :steps="stepsInfo" :options="tourOptions"></v-tour> -->
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import Telemetria from "@/components/cooperado/telemetria";
import Veiculo from "@/components/cooperado/veiculo";
import VueEasyLightbox from "vue-easy-lightbox";
import tourRdv from "@/tools/ajuda/tourRdv";
import limitesNormas from "@/components/cooperado/limitesNorma";


export default {
  mixins: [tourRdv],
  components: {
    PageHeader,
    Multiselect,
    Telemetria,
    Veiculo,
    VueEasyLightbox,
    limitesNormas, //Modal que abre as normas, esta componentizado para todas as carteiras.
  },

  data() {
    return {
      title: "rdv - relatório de despesas de viagem",
      items: [
        {
          text: "RDV Digital",
        },
      ],
      executarTour: false,
      tourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Sair",
          buttonPrevious: "Anterior",
          buttonNext: "Próximo",
          buttonStop: "Sair",
        },
      },
      stepsTour: [],
      tourCallbacks: {
        onFinish: this.finalizarTour,
        onStop: this.finalizarTour,
      },
      stepsInfo: [],
      despesasNaoVinculada: true,
      viewInfoRDV: false,
      viewValoresRDV: false,
      viewCarteiras: false,
      viewDespesas: false,
      viewEmitirRelatorio: false,
      loading: false,
      loadingExcluir: false,
      dados: {
        mesReferencia: "",
        projeto: "",
      },
      porcentagemDespesas: 0,
      porcentagemDisponivel: 0,
      listaRdv: [],
      cabecalhoRdv: {},
      optionProjeto: [],
      optionMesReferencia: [],
      valorDespesaTotal: "",
      camposDespesas: [
        {
          key: "detail",
          label: "",
        },
        {
          key: "ds_norma",
          label: "Transação/Despesa",
          sortable: true,
          thStyle: { "text-align-last": "start" },
        },
        {
          key: "ds_carteira",
          label: "Carteira",
          sortable: true,
        },
        {
          key: "dt_lancamento",
          label: "Data",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
          sortable: true,
        },
        {
          key: "vl_original",
          label: "Valor Original",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          sortable: true,
        },
        {
          key: "vl_lancamento",
          label: "Valor",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          sortable: true,
        },
        {
          key: "ds_st_lancamento",
          label: "Status/Saldo",
          class: "alinharCelula",
          sortable: true,
        },

        {
          key: "cidade_uf_movimento",
          label: "Cidade",
          sortable: true,
        },
        {
          key: "pendencias",
          label: "Pendências",
          sortable: true,
        },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          //thStyle: { width: "175px" }
        },
      ],
      tabelaDespesas: [],
      tabelaDespesasTransacoes: [],
      camposDespesasTransacoes: [
        {
          key: "ds_norma",
          label: "Norma",
          sortable: true,
          thStyle: { "text-align-last": "start" },
        },
        {
          key: "dt_lancamento",
          label: "Data",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
          sortable: true,
        },
        {
          key: "vl_lancamento",
          label: "Valor",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          sortable: true,
        },
        {
          key: "ds_st_lancamento",
          label: "Situação",
          class: "alinharCelula",
          sortable: true,
        },

        {
          key: "cidade_uf_movimento",
          label: "Cidade",
          sortable: true,
        },
        {
          key: "pendencias",
          label: "Pendências",
          sortable: true,
        },
        {
          key: "acoes",
          label: "Ações",
          class: "alinharCelulaDireita",
          sortable: false,
          thStyle: { width: "175px" },
        },
      ],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      settings: {
        dots: true,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 647,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      dadosCards: [],
      showModalNota: false,
      notaCombustivel: {},
      filtro: "",
      filtroAux: "",
      despesaTotal: 0,
      despesaAprovada: 0,
      despesaRejeitada: 0,
      tabelaDespesasAux: [],
      optionTabela: [
        "Saldo Pendente",
        "Despesas Não Vinculada",
        "Despesas Rejeitadas",
        "Despesas com Valor Alterado",
        "Despesas Justificadas",
      ],
      filtragemBadge: [],
      totalLancamentoVL: 0,
      totalOriginalVL: 0,
      totalLancamentoSemTransacoes: 0,
      permiteAdiantamento: false,
    };
  },

  created() {
    // Esvazia os parametros que são enviados para as telas das carteiras
    this.$store.commit("PARAMETROS_RDV_COOPERADO", null);

    this.filtroDataReferencia();
    // Verifica se tem notificação a ser exibida que veio das tela das carteiras
    if (this.$store.state.notificacao) {
      this.$tools.alerta(
        this.$store.state.notificacao.notificacao,
        this.$store.state.notificacao.icone
      );
      this.$store.commit("ENVIAR_NOTIFICACAO", null); //Esvazia notificação
    }
    // Chama stepstour assim que inicializa a tela para não dar erro!
    this.stepsTour = this.guiaTour();
  },

  mounted() {
    if (this.executarTour) {
      this.$tours["tourFiltro"].start();
    }
    // Carrega última seleção dos lookups, se existir
    const ultimoMesReferencia = localStorage.getItem("rdv_mesReferencia");
    if (ultimoMesReferencia) {
      try {
        this.dados.mesReferencia = JSON.parse(ultimoMesReferencia);
        // Se ambos os lookups estiverem preenchidos, chama o filtro automaticamente
        if (this.dados.mesReferencia && localStorage.getItem("rdv_projeto")) {
          const ultimoProjeto = localStorage.getItem("rdv_projeto");
          if (ultimoProjeto) {
            try {
              this.dados.projeto = JSON.parse(ultimoProjeto);
              // Chama o filtro para carregar as informações
              this.filtrarRdv();
            } catch (error) {
              console.error("Erro ao parsear último projeto:", error);
            }
          }
        }
      } catch (error) {
        console.error("Erro ao parsear último mês de referência:", error);
      }
    } else {
      const ultimoProjeto = localStorage.getItem("rdv_projeto");
      if (ultimoProjeto) {
        try {
          this.dados.projeto = JSON.parse(ultimoProjeto);
        } catch (error) {
          console.error("Erro ao parsear último projeto:", error);
        }
      }
    }
  },

  computed: {
    statusRdv() {
      if (this.cabecalhoRdv.st_rdv == "A" || this.cabecalhoRdv.st_rdv == "R") {
        return true;
      } else {
        return false;
      }
    },

    saldoDisponivel() {
      return this.cabecalhoRdv.vl_limite - this.cabecalhoRdv.vl_despesa;
    },
  },

  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },

    async filtroDataReferencia() {
      try {
        const meses = await this.$tools.filtroCooperado.buscarMesReferencia();
        this.optionMesReferencia = meses.map(el => ({
          dt_referencia: el.dt_referencia,
          vl_despesa: el.vl_despesa ?? '',
          cd_rdv: el.cd_rdv ?? '',
        }));
 
        if (!this.dados.mesReferencia) {
          this.dados.mesReferencia = "";
        }
      } catch (err) {
        console.log(err);
      }
    },

    async filtrarProjetos() {
      try {
        if (!this.dados.mesReferencia || !this.dados.mesReferencia.dt_referencia) {
          this.optionProjeto = [];
          return;
        }
        const projetos = await this.$tools.filtroCooperado.buscarProjetosPorReferencia(this.dados.mesReferencia.dt_referencia);
        this.optionProjeto = projetos.map(el => ({
          cd_projeto: el.cd_projeto,
          nm_projeto: el.nm_projeto,
          dt_referencia: el.dt_referencia,
          cd_rdv: el.cd_rdv
        }));
      } catch (err) {
        console.log(err);
      }
    },

    customLabelReferencia(dt_referencia) {
      return (
        this.$tools.mesesDoAno(parseInt(dt_referencia.substr(5, 2))) +
        "/" +
        dt_referencia.substr(0, 4) 
      );
    },

    async inputReferencia() {
      this.optionProjeto = [];
      this.dados.projeto = "";
      // Salva a última seleção do mês referência
      localStorage.setItem("rdv_mesReferencia", JSON.stringify(this.dados.mesReferencia));
      await this.filtrarProjetos();
    },

    inputProjeto() {
      localStorage.setItem("rdv_projeto", JSON.stringify(this.dados.projeto));
      // ...execute o restante da lógica do inputProjeto, se houver...
    },

    async filtrarRdv() {
      if (!this.dados.mesReferencia || !this.dados.projeto) {
        this.$tools.alerta("Favor preencher os campos", "warning");
        return;
      }
      try {
        this.loading = true;
        const params = {
          cd_projeto: this.dados.projeto.cd_projeto,
          dt_referencia: this.dados.mesReferencia.dt_referencia,
        };
        let response = await this.$http.get("api/cooperado/filtrarProjeto", { params });
        let rdv = response.data;
        this.cabecalhoRdv = rdv[0] || {};
        let limite = this.cabecalhoRdv.vl_limite;
        let despesas = this.cabecalhoRdv.vl_despesa;
        let disponivel = this.cabecalhoRdv.vl_disponivel;
        this.porcentagemDespesas = (despesas / limite) * 100;
        this.porcentagemDisponivel = (disponivel / limite) * 100;
        this.viewInfoRDV = true;
        this.viewValoresRDV = true;
        this.despesasNaoVinculada = true;
        this.filtrarDespesas();
      } catch (err) {
        console.log(err);
      }
    },

    filtrarDespesas() {
      this.despesaTotal = 0;
      this.despesaAprovada = 0;
      this.despesaRejeitada = 0;
      this.totalLancamentoVL = 0;
      this.totalOriginalVL = 0;
      this.totalLancamentoSemTransacoes = 0;
      this.tabelaDespesas = [];
      var tabelaAux = [];
      //Armazena o filtro
      this.$store.commit("FILTRO_OPERACAO", this.cabecalhoRdv.cd_rdv);
      //Armazena informações do RDV
      this.$store.commit("PARAMETROS_RDV_COOPERADO", {
        rdv: this.cabecalhoRdv,
      });
      this.$http
        .get("api/rdvCooperado/buscarDespesas/" + this.cabecalhoRdv.cd_rdv)
        .then((response) => {
          this.loading = false;
          tabelaAux = response.data;
          tabelaAux.forEach((el) => {
          el.despesas = [];

          if (el.nivel == 2 || el.nivel == 0) {
            this.totalLancamentoSemTransacoes += parseFloat(el.vl_original || 0);
          }
          
          if (el.nivel == 1) {
            if (parseInt(el.id_mastercard_transacao)) {
              el.despesas = tabelaAux.filter(
                (value) =>
                  value.nivel == 2 &&
                  parseInt(value.id_mastercard_transacao) ==
                    parseInt(el.id_mastercard_transacao)
              );
              if (el.despesas.length > 0) {
                el.despesas.forEach((item) => {
                  this.despesaTotal++;
                  if (item.st_rdv === "L") {
                    this.despesaAprovada++;
                  } else {
                    this.despesaRejeitada++;
                  }
                });
              }
            } else if (parseInt(el.id_visa_transacao)) {
              el.despesas = tabelaAux.filter(
                (value) =>
                  value.nivel == 2 &&
                  parseInt(value.id_visa_transacao) ==
                    parseInt(el.id_visa_transacao)
              );
              if (el.despesas.length > 0) {
                el.despesas.forEach((item) => {
                  this.despesaTotal++;
                  if (item.st_rdv === "L") {
                    this.despesaAprovada++;
                  } else {
                    this.despesaRejeitada++;
                  }
                });
              }
            }
            this.tabelaDespesas.push(el);
            this.totalOriginalVL += parseFloat(el.vl_original);
          } else if (el.nivel == 0) {
            this.despesaTotal++;
            if (el.st_lancamento === "L") {
              this.despesaAprovada++;
            } else if (el.st_lancamento === "R") {
              this.despesaRejeitada++;
            }
            this.tabelaDespesas.push(el);
            this.totalOriginalVL += parseFloat(el.vl_original);
          }
          else if (el.nivel == 2) {
            const temPaiMaster = el.id_mastercard_transacao &&
              tabelaAux.some(
                (pai) =>
                  pai.nivel == 1 &&
                  parseInt(pai.id_mastercard_transacao) == parseInt(el.id_mastercard_transacao)
              );
            const temPaiVisa = el.id_visa_transacao &&
              tabelaAux.some(
                (pai) =>
                  pai.nivel == 1 &&
                  parseInt(pai.id_visa_transacao) == parseInt(el.id_visa_transacao)
              );
            if (!temPaiMaster && !temPaiVisa) {
              this.despesaTotal++;
              if (el.st_rdv === "L" || el.st_lancamento === "L") {
                this.despesaAprovada++;
              } else if (el.st_rdv === "R" || el.st_lancamento === "R") {
                this.despesaRejeitada++;
              }
              this.tabelaDespesas.push(el);
              this.totalOriginalVL += parseFloat(el.vl_original);
            }
          }
          this.totalLancamentoVL += parseFloat(el.vl_lancamento);
        });

          var despesasTemp = [];
          var arrayTemp = this.tabelaDespesas.filter((value) => {
            return (
              value.despesas.length == 0 &&
              value.st_lancamento == "NV" &&
              !value.sq_transacao_motivo_falta
            );
          });
          despesasTemp.push(...arrayTemp);

          var statusLancamento = ["R", "J"];
          statusLancamento.forEach((el) => {
            var arrayTemp = this.tabelaDespesas.filter((value) => {
              return (
                value.st_lancamento == el ||
                this.verificarDespesasRejeitadas(value, [el, el])
              );
            });
            despesasTemp.push(...arrayTemp);
          });

          despesasTemp.forEach((el) => {
            var indexDespesa = this.tabelaDespesas.findIndex(
              (value) => value == el
            );
            this.tabelaDespesas.splice(indexDespesa, 1);
          });
          despesasTemp.push(...this.tabelaDespesas);
          this.tabelaDespesas = despesasTemp;

          this.tabelaDespesasAux = this.tabelaDespesas;
          this.currentPage = 1;
          this.rows = this.tabelaDespesas.length;

          this.$tools.fecharMenu();
          //this.buscarParametros(this.cabecalhoRdv.cd_matriz);
          this.$refs.telemetria.montandoGraficoDespesa(
            this.cabecalhoRdv.cd_rdv
          );
          this.$refs.telemetria.montandoGraficoCategoria(
            this.cabecalhoRdv.cd_rdv
          );
          this.$refs.telemetria.filtrarTelemetria(
            this.tabelaDespesas[0],
            this.cabecalhoRdv
          );
            // this.$refs.telemetria.filtrarAprimora(this.tabelaDespesas[0]);
          })
          .catch((err) => {
            console.log(err);
          });
        this.filtrarCarteira();
        this.$refs.veiculo.filtrarVeiculo(this.cabecalhoRdv.cd_rdv);
    },

    filtrarCarteira() {
      this.dadosCards = [];
      this.$http
        .get("api/rdvCooperado/buscarCarteiras/" + this.cabecalhoRdv.cd_rdv)
        .then((response) => {
          this.viewCarteiras = true;
          this.viewDespesas = true;
          this.dadosCards = response.data;
          if (this.dadosCards.length < 4) {
            this.settings.slidesToShow = this.dadosCards.length;
          } else {
            this.settings.slidesToShow = 4;
          }
          if (this.executarTour) {
            this.$tours["tourFiltro"].stop();
            this.gerenciarTourHelp(this.cabecalhoRdv.ds_st_rdv);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    verificarPendencias(item) {
      let pendencias = [];
      if (item.ds_tipo_carteira == "M" || item.ds_tipo_carteira == "V") {
        if (item.despesas.length == 0) {
          pendencias.push({
            nome: "Sem Despesa Vinculada",
            cor: "badge-soft-danger",
          });
          var difDias = new Date() - new Date(item.dt_usuinc);
          difDias = difDias / (1000 * 60 * 60 * 24);
          if (Math.trunc(difDias) > 90) {
            this.despesasNaoVinculada = false;
          }
        }
        if (
          item.despesas.reduce((a, b) => a + parseFloat(b.vl_lancamento), 0) !=
          parseFloat(item.vl_original)
        ) {
          pendencias.push({ nome: "Saldo Pedente", cor: "badge-soft-warning" });
        }
        item.despesas.some((el) => {
          if (el.st_lancamento == "R") {
            pendencias.push({
              nome: "Existe Despesas Rejeitada",
              cor: "badge-soft-danger",
            });
            return true;
          }
          if (el.st_lancamento == "J") {
            pendencias.push({
              nome: "Existe Despesas Pré-Rejeitada",
              cor: "badge-soft-danger",
            });
            return true;
          }
        });
      } else if (
        item.ds_carteira == "Recurso próprio" ||
        item.ds_carteira == "Adiantamento"
      ) {
        if (item.vl_lancamento && item.vl_original != item.vl_lancamento) {
          pendencias.push({
            nome: "Despesa Valor Alterado",
            cor: "badge-soft-primary",
          });
        }
        if (item.st_lancamento == "R" || item.st_lancamento == "J") {
          pendencias.push({
            nome: "Despesa Rejeitada",
            cor: "badge-soft-danger",
          });
        }
      } else if (item.ds_tipo_carteira == "U") {
        if (item.st_lancamento == "NV") {
          pendencias.push({
            nome: "Despesa Não Vinculada",
            cor: "badge-soft-danger",
          });
        }
      }
      return pendencias;
    },

    verificarDespesasRejeitadas(item, stLancamento = ["R", "J"]) {
      var retorno = false;
      item.despesas.some((el) => {
        if (
          el.st_lancamento == stLancamento[0] ||
          el.st_lancamento == stLancamento[1]
        ) {
          retorno = true;
        }
      });
      return retorno;
    },

    async buscarComprovante(event) {
      this.notaCombustivel = {};
      const response = await this.$http.get("api/rdvCooperado/buscarDespesas/" + this.cabecalhoRdv.cd_rdv);

      let item = response.data.find((el) => {
        if (el.sq_lancamento === event) {
          return true;
        } 
        return false;
      });
      if (item) { 
        this.notaCombustivel =
          await this.$tools.filtroCooperado.buscarComprovante(item.sq_upload);
      }

      if (this.notaCombustivel.comprovante) {
        this.showModalNota = true;
      } else {
        this.$tools.alerta("Não achou o comprovante", "error");
      }
    },

    redirecionarParaCarteiras(acao, carteira, item = {}) {

      const sq_veiculo = this.$refs.veiculo?.sq_veiculoSelecionado || null;
      this.$store.commit("PARAMETROS_RDV_COOPERADO", {
        acao: acao,
        item: item,
        rdv: this.cabecalhoRdv,
        sq_veiculo: sq_veiculo,
      });
      if (carteira == "Recurso próprio") {
        if (acao == "N" && !this.despesasNaoVinculada) {
          this.$tools.alerta(
            "Existem transações pendentes, sem despesa vinculada e/ou comprovantes anexados. Não é possível inserir despesas de Adiantamento/Recurso Próprio.",
            "error"
          );
        } else {
          this.$router.push({ path: "rdv/carteira/recursoProprio/" });
        }
      } else if (carteira == "Adiantamento") {
        if (acao == "N" && !this.despesasNaoVinculada) {
          this.$tools.alerta(
            "Existem transações pendentes, sem despesa vinculada e/ou comprovantes anexados. Não é possível inserir despesas de Adiantamento/Recurso Próprio.",
            "error"
          );
        } else {
          this.$router.push({ path: "rdv/carteira/adiantamento/" });
        }
      } else if (carteira == "Good Card") {
        this.$router.push({ path: "rdv/carteira/goodCard/" });
      } else if (carteira == "Mastercard") {
        this.$router.push({ path: "rdv/carteira/masterCard/" });
      } else if (carteira == "Visa") {
        this.$router.push({ path: "rdv/carteira/visa/" });
      }
    },

    buscarImagemPrincipios() {
      this.$router.push({ path: "rdv/principios" });
    },

    redirecionarParaJustificativa(acao, item = {}) {
      this.$store.commit("PARAMETROS_RDV_COOPERADO", {
        acao: acao,
        item: item,
        rdv: this.cabecalhoRdv,
      });
      this.$router.push({ path: "rdv/carteira/justificarPendencia/" });
    },

    emitirRelatorio() {
      this.viewEmitirRelatorio = true;
      this.$http
        .get("api/rdvCooperado/gerarRelatorio/" + this.cabecalhoRdv.cd_rdv, {
          responseType: "blob",
        })
        .then((response) => {
          var blob = new Blob([response.data], {
            type: "application/pdf",
          });
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          this.viewEmitirRelatorio = false;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },

    emitirExtratoDeAcerto() {
      if (this.viewDespesas == false) {
        this.$tools.alerta("Filtre as despesas primeiro", "warning");
        return;
      } else {
        window.open("rdv/extrato");
      }
    },

    tourHelp(param) {
      var objinfo = {};
      switch (param) {
        case "resumoRdv":
          objinfo = {
            target: '[data-v-step="3"]',
            content: "Essas são suas <strong>carteiras disponíveis</strong>",
            params: {
              placement: "top",
              enableScrolling: false,
            },
          };
          break;
        case "teste":
          objinfo = {
            target: '[data-v-step="20"]',
            content: "teste",
            params: {
              placement: "top",
              enableScrolling: false,
            },
          };
          break;
      }
      if (this.stepsInfo.length != 1) {
        this.stepsInfo.push(objinfo);
      } else {
        this.stepsInfo.splice(0, 1, objinfo);
      }
      this.$tours["tourInfo"].start();
    },

    iniciarTour() {
      this.dados.projeto = [
        { nm_projeto: "PROJETO DEMONSTRAÇÃO COOPERADO", cd_projeto: "9999" },
      ];
      this.dados.mesReferencia = [
        { dt_referencia: "2022-01-01 00:00:00", vl_despesa: "9999" },
      ];
      this.dadosCards = [];
      this.cabecalhoRdv = {};
      (this.tabelaDespesas = []), (this.executarTour = true);

      // Preenchendo com dados falsos para o Tour
      this.cabecalhoRdv = this.cabecalhoRdvTour();
      this.dadosCards = this.dadosCardsTour();
      this.tabelaDespesas = this.tabelaDespesasTour();
      var veiculosTour = this.veiculosTour();

      this.$refs.veiculo.inputDadosFakeTour(veiculosTour);
      this.$refs.telemetria.montandoGraficoDespesa(
        this.$tools.criarGraficoDespesas(this.tabelaDespesas), true
      );

      this.porcentagemDespesas = 15;
      this.porcentagemDisponivel = 85;
      this.viewInfoRDV = true;
      this.viewValoresRDV = true;
      this.viewCarteiras = true;
      this.viewDespesas = true;
      this.$tools.fecharMenu();
      this.$tours["tourRdvCooperado"].start();
    },

    limparPesquisa() {
      this.$store.commit("FILTRO_OPERACAO", null);
      this.viewCarteiras = false;
      this.viewDespesas = false;
      this.viewInfoRDV = false;
      this.viewValoresRDV = false;
      this.$refs.veiculo.limparPesquisa();
      this.$refs.telemetria.limparPesquisa();
      this.dados.mesReferencia = "";
      this.dados.projeto = "";
      // Limpa as seleções salvas
      localStorage.removeItem("rdv_mesReferencia");
      localStorage.removeItem("rdv_projeto");
    },

    async removerDespesa(item, data) {
      try {
        await this.$tools.alertaConfirm("Tem certeza que deseja excluir?");
      } catch {
        return;
      }
      this.loadingExcluir = true;
      item.cd_projeto = this.cabecalhoRdv.cd_projeto;
      try {
        if (item.ds_tipo_carteira == "A") {
          await this.$tools.filtroCooperado.excluirAdiantamento(item);
          let index = this.tabelaDespesas.findIndex(
            (el) => el.sq_lancamento == item.sq_lancamento
          );
          this.tabelaDespesas.splice(index, 1);
        } else if (item.ds_tipo_carteira == "P") {
          await this.$tools.filtroCooperado.excluirRecursoProprio(item);
          let index = this.tabelaDespesas.findIndex(
            (el) => el.sq_lancamento == item.sq_lancamento
          );
          this.tabelaDespesas.splice(index, 1);
        } else if (item.ds_tipo_carteira == "M") {
          await this.$tools.filtroCooperado.excluirMastercard(item);
          let index = this.tabelaDespesas.findIndex(
            (el) =>
              parseInt(el.id_mastercard_transacao) ==
              parseInt(item.id_mastercard_transacao) && el.nivel == 1
          );
          let indexAux = this.tabelaDespesas[index].despesas.findIndex(
            (el) =>
              parseInt(el.sq_lcto_mastercard_transacao) ==
              parseInt(item.sq_lcto_mastercard_transacao)
          );
          this.tabelaDespesas[index].despesas.splice(indexAux, 1);
          data.toggleDetails();
        } else if (item.ds_tipo_carteira == "V") {
          await this.$tools.filtroCooperado.excluirVisa(item);
          let index = this.tabelaDespesas.findIndex(
            (el) =>
              parseInt(el.id_visa_transacao) ==
              parseInt(item.id_visa_transacao) && el.nivel == 1
          );
          let indexAux = this.tabelaDespesas[index].despesas.findIndex(
            (el) =>
              parseInt(el.sq_lcto_visa_transacao) ==
              parseInt(item.sq_lcto_visa_transacao)
          );
          this.tabelaDespesas[index].despesas.splice(indexAux, 1);
          data.toggleDetails();
        }
        this.$tools.alerta("Removido com sucesso", "success");
        this.loadingExcluir = false;
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
        this.loadingExcluir = false;
      }
    },

    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },

    filtrarTabelaDespesa() {
      var str = this.filtro.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (str) {
        this.filtroAux = str[3] + "-" + str[2] + "-" + str[1];
      } else {
        this.filtroAux = this.filtro;
      }
    },

    verificarImagemNorma(item) {
      try {
        return require(`@/assets/images/logo-normas/${item.cd_norma}.svg`);
      } catch {
        return require(`@/assets/images/logo-normas/7.svg`);
      }
    },

    verificarImagemCarteira(item) {
      try {
        return require("@/assets/assetsRdv/" + item);
      } catch {
        return require(`@/assets/assetsRdv/assets/bank/001.png`);
      }
    },

    filtraTabelaCheckbox() {
      var despesaAux = [];
      if (this.filtragemBadge.length == 0) {
        this.tabelaDespesas = this.tabelaDespesasAux;
        this.rows = this.tabelaDespesas.length;
        this.currentPage = 1;
        return;
      }
      this.tabelaDespesasAux.forEach((item) => {
        if (item.ds_tipo_carteira == "M" || item.ds_tipo_carteira == "V") {
          if (
            this.filtragemBadge.includes("Saldo Pendente") &&
            !despesaAux.includes(item)
          ) {
            if (
              item.despesas.reduce(
                (a, b) => a + parseFloat(b.vl_lancamento),
                0
              ) != parseFloat(item.vl_original)
            ) {
              despesaAux.push(item);
            }
          }
          if (
            this.filtragemBadge.includes("Despesa Não Vinculada") &&
            item.despesas.length == 0 &&
            !despesaAux.includes(item)
          ) {
            despesaAux.push(item);
          }
          if (
            this.filtragemBadge.includes("Despesas Rejeitadas") &&
            !despesaAux.includes(item)
          ) {
            item.despesas.some((el) => {
              if (el.st_lancamento == "R") {
                despesaAux.push(item);
              }
            });
          }
          if (
            this.filtragemBadge.includes("Despesa Não Vinculada") &&
            item.despesas.length == 0 &&
            !despesaAux.includes(item)
          ) {
            despesaAux.push(item);
          }
        } else if (
          item.ds_carteira == "Recurso próprio" ||
          item.ds_carteira == "Adiantamento"
        ) {
          if (
            this.filtragemBadge.includes("Despesa Valor Alterado") &&
            !despesaAux.includes(item) &&
            item.vl_lancamento &&
            item.vl_original != item.vl_lancamento
          ) {
            despesaAux.push(item);
          }
          if (
            this.filtragemBadge.includes("Despesas Rejeitadas") &&
            !despesaAux.includes(item) &&
            (item.st_lancamento == "R" || item.st_lancamento == "J")
          ) {
            despesaAux.push(item);
          }
        } else if (item.ds_tipo_carteira == "U") {
          if (
            this.filtragemBadge.includes("Despesa Não Vinculada") &&
            !despesaAux.includes(item) &&
            item.st_lancamento == "NV"
          ) {
            despesaAux.push(item);
          }
        }
        if (
          this.filtragemBadge.includes("Despesas Justificadas") &&
          item.sq_transacao_motivo_falta &&
          !despesaAux.includes(item)
        ) {
          despesaAux.push(item);
        }
      });
      this.tabelaDespesas = despesaAux;
      this.rows = this.tabelaDespesas.length;
      this.currentPage = 1;
    },

    finalizarTour() {
      this.$refs.veiculo.inputDadosFakeTour("Tirar dados fakes");
      this.$refs.telemetria.montandoGraficoDespesa("Tirar dados fakes");
      this.executarTour = false;
      this.dadosCards = [];
      this.cabecalhoRdv = {};
      this.tabelaDespesas = [];
      this.dados.projeto = [];
      this.dados.mesReferencia = [];
      this.porcentagemDespesas = 0;
      this.porcentagemDisponivel = 0;
      this.viewInfoRDV = false;
      this.viewValoresRDV = false;
      this.viewCarteiras = false;
      this.viewDespesas = false;
    },

    async buscarParametros(cdMatriz) {
      //Verifica se permite adiantamento
      var parametros = await this.$tools.filtroCooperado.buscarParametros();
      parametros.forEach((el) => {
        if (el.cd_matriz == cdMatriz) {
          this.permiteAdiantamento = true;
        }
      });
    },

    redirecionaSolicitacaoAdiantamento() {
      var countDespesasNaoVinculada = 0;
      this.tabelaDespesas.forEach((el) => {
        if (
          (el.ds_tipo_carteira == "M" || el.ds_tipo_carteira == "V") &&
          !el.sq_transacao_motivo_falta
        ) {
          if (el.despesas.length == 0) {
            var difDias = new Date() - new Date(el.dt_usuinc);
            difDias = difDias / (1000 * 60 * 60 * 24);
            if (Math.trunc(difDias) > 5) {
              countDespesasNaoVinculada++;
            }
          }
        }
      });
      if (countDespesasNaoVinculada == 0) {
        var link =
          "/cooperado/rdv/carteira/adiantamento/solicitacao/" +
          this.cabecalhoRdv.cd_rdv;
        this.$router.push({ path: link });
      } else {
        this.$tools.alerta(
          `Existe(m) ${countDespesasNaoVinculada} transação(ões) pendente(s), sem despesa(s) vinculada(s) e/ou comprovantes anexados. Não é possível realizar a solicitação.`,
          "error"
        );
      }
    },
    abrirModalNormas() {
      this.$refs.normasModal.abrirModal(this.cabecalhoRdv.cd_projeto);
    },

  },
};
</script>

<style scoped>
.limiteGlobalLinha {
  width: 33%;
  background-color: #74788d;
  border-radius: 2px 2px 0 0;
}

.despesasTotaisLinha {
  width: 33%;
  background-color: #0d6efd;
}

.disponivelLinha {
  width: 33%;
  background-color: #34c38f;
}



.heightCardHeader {
  height: 95%;
}

.heightCardCarteiras {
  height: 340px;
}

.logo-cards {
  width: 3rem;
}

.alinharLinha {
  vertical-align: middle;
}

.border-tour {
  border-color: darkgrey;
  border-style: solid;
  border-width: initial;
}
</style>
